import React from 'react';
import { FadeIn } from './FadeIn';
import { Gift } from 'lucide-react';
export function BonusSection() {
  return <section className="py-16 px-6 bg-brand-light" data-id="element-9">
      <div className="max-w-4xl mx-auto" data-id="element-10">
        <FadeIn data-id="element-11">
          <div className="bg-brand-terracotta text-white p-8 md:p-16 rounded-3xl shadow-xl relative overflow-hidden" data-id="element-12">
            <div className="absolute top-0 right-0 w-64 h-64 bg-white opacity-10 rounded-full transform translate-x-1/3 -translate-y-1/3" data-id="element-13"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-brand-brown opacity-10 rounded-full transform -translate-x-1/3 translate-y-1/3" data-id="element-14"></div>

            <div className="relative z-10 text-center" data-id="element-15">
              <div className="bg-white text-brand-terracotta w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-8 shadow-md" data-id="element-16">
                <Gift className="w-10 h-10" data-id="element-17" />
              </div>
              <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6" data-id="element-18">
                Y Además Recibe Este Regalo Extra…
              </h2>
              <div className="bg-white bg-opacity-20 p-8 rounded-2xl mt-8 border border-white border-opacity-30 max-w-2xl mx-auto backdrop-blur-sm" data-id="element-19">
                <h3 className="text-2xl md:text-3xl font-bold mb-4 font-serif" data-id="element-20">
                  Guía: "Zapatos Amigos"
                </h3>
                <p className="text-lg md:text-xl opacity-95 leading-relaxed" data-id="element-21">
                  Qué calzado está arruinando su postura hoy mismo y cómo elegir
                  el correcto para proteger sus rodillas.
                </p>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}